<template>
	<div class="main-table">
		<div class="fx-title">
			<p>退单商品信息</p>
		</div>
		<div class="main-table-box">
			<div style="display:flex">
				<el-button type="primary" size='small' class="fx-big-btn valet-add-btn" plain @click="addGoods" :disabled="!acountValue">添加退单商品</el-button>
			</div>
			<el-table
				class="grid-content"
				:data="tableData"
				border
			>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="70"
					align="center"
					fixed>
				</el-table-column>
				<el-table-column
					prop="pname"
					label="商品名称"
					align="center"
					min-width="80"
					fixed>
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
							<div v-if="scope.row.giftflag" class="giftLogo">赠品</div>
							<div>{{scope.row.pname}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="pcode"
					label="商品编号"
					width="220"
					align="center">
				</el-table-column>
				<el-table-column
					v-if="matchbillcenterflag === 1"
					prop="code"
					label="第三方编号"
					align="center"
					min-width="160"
					:show-overflow-tooltip = "true">
					<template slot-scope="scope">
						<div>{{scope.row.matchcode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="specCode"
					width="220"
					label="规格编号"
					align="center">
				</el-table-column>
				<el-table-column
					prop="price"
					label="规格"
					align="center">
					<template slot-scope="scope">
						{{scope.row.spec}}
					</template>
				</el-table-column>
				<el-table-column
					prop="price"
					label="单价"
					align="center">
					<template slot-scope="scope">
						{{$fxUtils.toFixedSHW(scope.row.price, 2)}}
					</template>
				</el-table-column>
				<el-table-column
					prop="price"
					label="优惠后单价"
					align="center">
					<template slot-scope="scope">
						{{$fxUtils.toFixedSHW(scope.row.refundprice, 2)}}
					</template>
				</el-table-column>
				<el-table-column
					prop="itemquantity"
					label="申请退货数量"
					align="center"
					header-align="center"
					width="360">
					<template slot-scope="scope">
						<div>
							<el-input-number @change="numChange(scope.row)" size="mini" :min="0" v-model="scope.row.refundquantity" :step="1"></el-input-number>
							<div style="display: inline-block;text-align: left;margin-left:10px;">
								<span>{{scope.row.punit}}</span>
								<span style="margin-left:10px;">最大可能退{{scope.row.refundMaxQuantity}}{{scope.row.punit}}</span>
							</div>
						</div>
						<div v-if="scope.row.useunitflag === 1 && matchbillcenterflag === 1">
							<el-input-number style="margin-top: 10px;" @change="numChange(scope.row)" size="mini" :min="0" v-model="scope.row.refundassistquantity" :step="1"></el-input-number>
							<div style="display: inline-block;text-align: left;margin-left:10px;">
								<span>{{scope.row.assistunit}}</span>
								<span style="margin-left:10px;">最大可能退{{scope.row.refundMaxAssistQuantity}}{{scope.row.assistunit}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="itemmoney"
					label="小计"
					align="center">
					<template slot-scope="scope">
						<div v-if="!scope.row.giftflag">{{scope.row.itemmoney}}</div>
						<div v-else>0.00</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="deleteSingle(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="goods-total">
			<div><span>商品金额合计：</span>￥{{goodsMoney}}</div>
		</div>
		<el-dialog
			title="添加商品"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="1200px"
			@close='dialogClose'
			@open="search()"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="refund-filters-container">
					<div class="input-box">
						<span>搜索：</span>
						<el-input
							v-model="goodsName"
							placeholder="请输入商品名称/编号"
							size="small"
							@keyup.enter.native="search()">
						</el-input>
					</div>
					<el-button size="small" type="primary" class="btn fx-btn" @click="search()">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clear">清空</el-button>
				</div>
				<div class="refund-filters-container">
					订单编号：
					<a class="input-box underline">
						{{orderobj.ordernumber}}
					</a>
				</div>
				<el-table
					class="grid-content"
					:data="tableData2"
					border
					max-height="450"
					@selection-change="selectionChangeHandle"
					ref="DataTable"
				>
					<el-table-column
						type="selection"
						align="center"
						width="55"
						fixed>
					</el-table-column>
					<el-table-column
						label-class-name="column-index"
						label="序号"
						type="index"
						width="70"
						align="center"
						fixed>
					</el-table-column>
					<el-table-column
						prop="pname"
						label="商品名称"
						align="center"
						fixed>
					</el-table-column>
					<el-table-column
						prop="pcode"
						label="商品编号"
						width="220"
						align="center">
					</el-table-column>
					<el-table-column
						v-if="matchbillcenterflag === 1"
						prop="code"
						label="第三方编号"
						align="center"
						min-width="160"
						:show-overflow-tooltip = "true">
						<template slot-scope="scope">
							<div>{{scope.row.matchcode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="specCode"
						width="220"
						label="规格编号"
						align="center">
					</el-table-column>
					<el-table-column
						prop="spec"
						label="规格"
						align="center">
					</el-table-column>
					<el-table-column
						prop="price"
						label="单价"
						align="center">
						<template slot-scope="scope">
							{{$fxUtils.toFixedSHW(scope.row.price, 2)}}
						</template>
					</el-table-column>
					<el-table-column
						prop="itemquantity"
						label="订货数"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.itemquantity}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="sendcount"
						label="实发数"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.sendcount}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="getcount"
						label="实收数"
						align="center">
						<template slot-scope="scope">
							<div>{{scope.row.getcount}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="memo"
						label="备注"
						align="center">
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click="addSingle(scope.row)">添加</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="valet-foot">
					<el-button class="btn" plain type="primary" size='small' @click="close">取消</el-button>
					<el-button class="btn" plain type="primary" size='small' @click="addMulti">添加</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="padding-bottom:20px" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		shopId: {
			type: String
		},
		organid: {
			type: String
		},
		buyersyscodeid: {
			type: String
		},
		acountValue: {
			type: String
		},
		orderobj: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			dialogVisible: false,
			tipModal: false,
			tableData: [],
			tableData2: [],
			tipData: [],
			goodsMoney: '0.00',
			freight: 0,
			totalMoney: '0.00',
			goodsName: '',
			selectNum: 0,
			selectTableData: [],
			matchbillcenterflag: 1,
			actualtimeinventoryflag: 1, // 0：不开启实时库存 1：开启实时库存
			orderNumberRoundRules: null,
			orderdecimalcount: null,
			dataObj: {},
			oipids: []
		}
	},
	watch: {
		orderobj: {
			handler (val) {
				this.oipids = []
				this.goodsMoney = '0.00'
			}
		}
	},
	created () {
		this.checkSmallCategory()
		this.getSystemSetting()
	},
	mounted () {
	},
	methods: {
		numBlur (row) {
			row.itemquantity = +row.itemquantity
		},
		checkNum (row) {
			console.log(row)
			row.itemquantity = row.itemquantity + ''
			row.itemquantity = row.itemquantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.itemquantity = row.itemquantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.itemquantity = row.itemquantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.itemquantity = row.itemquantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.orderdecimalcount) {
			case 0:
				row.itemquantity = row.itemquantity.replace(/[^0-9]/g, '')// 只能输入数字
				break
			case 1:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.itemquantity = row.itemquantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			row.itemquantity = +row.itemquantity
		},
		priceBlur (row) {
			row.realPrice = this.$fxUtils.toFixedSHW(row.realPrice, 2)
		},
		priceChange (row, name, type) {
			if (row.realPrice === undefined || +row.realPrice < 0) {
				row.realPrice = '0.00'
			}
			if (row.realPrice === '') {
				row.realPrice = ''
			}
			if (+row.realPrice > 999999.99) {
				row.realPrice = 999999.99
			}
			// this.priceBlur(row)
			if (type === 2) {
				this.calcGoodsMoney()
			}
		},
		checkPrice (item, name, type) {
			item[name] = item[name].replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			item[name] = item[name].replace(/^\./g, '')// 验证第一个字符是数字而不是
			item[name] = item[name].replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			item[name] = item[name].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			item[name] = item[name].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入一个小数
			if (type === 2) {
				this.calcGoodsMoney()
			}
		},
		clearAll () {
			this.tableData = []
			this.goodsMoney = '0.00'
		},
		getSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderSystemSetting`
			}).then(res => {
				this.orderNumberRoundRules = res.data.ordermoneyroundrules
				this.orderdecimalcount = res.data.orderdecimalcount
			})
		},
		// 是否对接中台
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
				this.actualtimeinventoryflag = res.actualtimeinventoryflag
				this.$emit('matchbillcenterflag', this.matchbillcenterflag)
			})
			// })
		},
		// 计算价格
		calcGoodsMoney () {
			let price = 0
			let num = 0
			this.tableData.forEach(item => {
				console.log(item.refundMaxQuantity, item.refundquantity, item.refundmoney)
				var quantity = item.refundMaxQuantity === +item.refundquantity ? item.refundmoneyFixed : (item.refundquantity * item.refundprice)
				item.itemmoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(quantity, 2) : this.toFix(quantity)
				if (!item.giftflag) {
					price += +item.itemmoney
					item.refundmoney = item.itemmoney
				} else {
					item.refundmoney = 0
				}
				if (item.speprice) {
					item.speprice = item.realPrice
				} else {
					item.customPrice = item.realPrice
				}
			})
			this.selectTableData.forEach(item => {
				if (item.giftflag) {
					num++
				}
			})
			this.giftNum = num
			this.goodsMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(price, 2) : this.toFix(price)
			this.totalMoney = this.orderNumberRoundRules === 0 ? this.$fxUtils.toFixedSHW(+this.goodsMoney + (+this.freight), 2) : this.toFix(+this.goodsMoney + (+this.freight))
		},
		toFix (price) {
			if (+price === 0) {
				return '0.00'
			}
			let num = isNaN(price) ? 0 : price
			num = +num + 0.0000000001
			num = num + ''
			if (num.indexOf('.') !== -1) {
				num = num.substring(0, num.indexOf('.') + 3)
			}
			return num
		},
		// 修改数量
		quantityInput (e) {
			// this.checkNum(e)
			this.calcGoodsMoney()
		},
		numChange (e) {
			console.log(e)
			this.checkNum(e)
			this.calcGoodsMoney()
		},
		removeByValue (arr, val) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i] === val) {
					arr.splice(i, 1)
					break
				}
			}
		},
		// 删除商品
		deleteSingle (index, item) {
			this.tableData.splice(index, 1)
			console.log(item)
			this.removeByValue(this.oipids, item.oipid)
			this.calcGoodsMoney()
			this.$message.success('删除成功')
			// this.calcFreight()
		},
		// 单个添加
		addSingle (item) {
			console.log(item)
			this.oipids.push(item.oipid)
			this.tableData.push(item)
			console.log(this.tableData)
			this.calcGoodsMoney()
			this.$message.success('添加成功！')
			this.search('afterAdd')
		},
		// 批量添加
		addMulti () {
			console.log(this.selectTableData)
			let selectData = this.$refs.DataTable.selection
			if (selectData.length === 0) {
				this.$message.error('请选择商品！')
				return false
			}
			selectData.forEach(item => {
				this.tableData.push(item)
				this.oipids.push(item.oipid)
			})
			this.calcGoodsMoney()
			this.$message.success('添加成功！')
			this.search()
			// this.search()
			// this.calcFreight()
			// this.dialogVisible = false
		},
		search (val) {
			let data = {
				oipids: this.oipids.length !== 0 ? this.oipids : null,
				orderid: this.orderobj.orderid,
				keyword: this.goodsName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replacerefundorder/orderdetail`,
				data: data
			}).then(res => {
				if (res.result) {
					res.data.forEach((e, index) => {
						e.selected = false
						e.currentIndex = index
						e.refundmoneyFixed = e.refundmoney
					})
					this.tableData2 = res.data
				} else {
					this.tableData2 = []
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		clear () {
			this.goodsName = ''
			this.search()
		},
		selectionChangeHandle (value) {
			this.selectTableData = value
			this.selectoipids = value.map((item) => {
				return item.oipid
			})
		},
		addGoods () {
			this.dialogVisible = true
		},
		dialogClose () {
			this.tableData2 = []
			this.goodsName = ''
		},
		close () {
			this.dialogVisible = false
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	// flex: 1
	flex-direction: column
	// height: 100%
	padding-left: 10px
	font-size: 14px
	margin-top: 10px
	text-align: left
	.fx-title {
		font-weight: 700
		margin: 10px 0 10px 0
	}
	.info-box {
		text-align: left
		&>div {
			// display: flex
			// align-items: center
			padding-left: 14px
			margin-top: 15px
		}
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
		.valet-add-btn {
			margin: 10px 10px 10px 0
		}
		.shop-info{
			display: flex
			justify-content: center;
		}
	}
	.goods-total {
		display: flex
		flex-direction: column
		justify-content: flex-end
		padding-left: 60%
		margin: 20px 0
		&>div {
			margin: 3px 0
			&>span {
				display: inline-block
				width: 110px;
				text-align: right
			}
		}
		.el-input {
			width: 100px
		}
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin: 10px;
		margin-left: 0;
		width: 100px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
}
</style>
<style lang="stylus">
.giftLogo{
	margin-right :5px;
	font-size :10px;
	width: 34px;
	height: 18px;
	line-height: 18px;
	color: var(--fx-primary-color);
	border: 1px solid var(--fx-primary-color);
	border-radius :5px;
}
.spec-title {
	width: 14px;
	height: 14px;
	position: absolute;
	top: 4px;
	right: 15px;
	cursor: pointer
}
.border-red input.el-input__inner{
	border-color: #F56C6C
}
.main-table {
	.el-dialog {
		margin-top: 5vh!important
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-pagination {
		text-align: center;
		margin-top: 10px
	}
	.valet-foot {
        height :40px;
        margin-top: 10px;
		text-align: center
		position :relative
        .btn{
            width :120px;
			height :35px;
			margin: 0 30px
        }
		.tip-box{
			position :absolute;
			width:400px;
			bottom :8px;
			text-align :left;
			left :750px;
			color :#999999
		}
	}
	.el-radio {
		margin-right: 20px;
		&:last-child {
			margin-right: 0
		}
	}
	.btn-box {
		display flex
		justify-content: center
		.el-button {
			width: 120px
		}
	}
	.refund-filters-container {
		margin-right: 15px
		display: flex
		align-items: center
		margin-bottom: 20px
		.input-box {
			margin-right: 20px
		}
		.underline {
			color: var(--fx-primary-color);
			text-decoration: underline;
			margin-left:5px;
			cursor: pointer
		}
		.el-input {
			width: 160px
		}
		.filter-input {
			width: 160px
		}
	}
}
</style>
